import type { ProductRole } from '@academy/domain';

export const routeCapabilities = {
  overview: [
    'ACADEMY_ADMIN',
    'ACADEMIC_COORDINATOR',
    'TEACHER',
    'STUDENT',
    'GUARDIAN',
    'SUPPORT',
    'SAFETY_OFFICER',
    'PRIVACY_OFFICER',
    'AUDITOR',
  ],
  account: [
    'ACADEMY_ADMIN',
    'ACADEMIC_COORDINATOR',
    'TEACHER',
    'STUDENT',
    'GUARDIAN',
    'SUPPORT',
    'SAFETY_OFFICER',
    'PRIVACY_OFFICER',
    'AUDITOR',
  ],
  accessAdministration: ['ACADEMY_ADMIN', 'SUPPORT'],
  people: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER'],
  guardianProfiles: ['ACADEMY_ADMIN', 'PRIVACY_OFFICER', 'GUARDIAN'],
  groups: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER'],
  curriculum: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER'],
  schedule: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER', 'STUDENT', 'GUARDIAN'],
  presentationStudio: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER'],
  delivery: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER', 'STUDENT'],
  learning: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER', 'STUDENT', 'GUARDIAN'],
  assessment: ['ACADEMY_ADMIN', 'ACADEMIC_COORDINATOR', 'TEACHER', 'STUDENT', 'GUARDIAN'],
  messages: [
    'ACADEMY_ADMIN',
    'ACADEMIC_COORDINATOR',
    'TEACHER',
    'STUDENT',
    'GUARDIAN',
    'SUPPORT',
    'SAFETY_OFFICER',
    'PRIVACY_OFFICER',
    'AUDITOR',
  ],
  privacy: [
    'ACADEMY_ADMIN',
    'ACADEMIC_COORDINATOR',
    'TEACHER',
    'STUDENT',
    'GUARDIAN',
    'SUPPORT',
    'SAFETY_OFFICER',
    'PRIVACY_OFFICER',
    'AUDITOR',
  ],
  privacyAdministration: ['ACADEMY_ADMIN', 'PRIVACY_OFFICER'],
  privacySafety: [
    'ACADEMY_ADMIN',
    'ACADEMIC_COORDINATOR',
    'TEACHER',
    'STUDENT',
    'GUARDIAN',
    'SUPPORT',
    'SAFETY_OFFICER',
    'PRIVACY_OFFICER',
    'AUDITOR',
  ],
  operations: ['ACADEMY_ADMIN', 'SUPPORT', 'AUDITOR'],
  academyAdministration: ['ACADEMY_ADMIN', 'PRIVACY_OFFICER', 'AUDITOR'],
} as const satisfies Record<string, readonly ProductRole[]>;

export type RouteCapability = keyof typeof routeCapabilities;

export const hasRouteCapability = (
  accountRoles: readonly ProductRole[],
  capability: RouteCapability,
) => routeCapabilities[capability].some((role) => accountRoles.includes(role));
